import { DisqualifiedReason } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'

export type DisqualifiedReasonOption = {
  value: DisqualifiedReason
  label: string
}

// Sorted by the label the user reads so the dropdown stays alphabetical even
// when a label doesn't match its enum value's ordering.
export const DISQUALIFIED_REASON_OPTIONS: DisqualifiedReasonOption[] =
  Object.values(DisqualifiedReason)
    .map((reason) => ({
      value: reason,
      label: formatSnakeValue(reason),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
